<template>
    <div class="uk-margin-remove">
        <h3 class="dr-active-filter-title uk-h4 uk-margin-small-bottom">
            <div v-if="list_status_message" v-html="list_status_message"></div>
        </h3>
        <div class="uk-grid uk-grid-xsmall uk-visible@s uk-margin-xsmall-bottom" uk-grid>
            <dr-filter-tag
                v-if="selectedDate.value"
                :key="selectedDate.value"
                :type="'date'"
                :filterTagText="selectedDate.value"
            />
            <dr-filter-tag
                v-for="(item, index) in checkedFilter"
                :index="index"
                :key="item.label"
                :type="'checkbox'"
                :filterTag="item"
                :filterTagText="item.label"
            />
            <div v-if="checkedFilter.length > 1 || (checkedFilter.length >= 1 && selectedDate.value)">
                <div class="uk-height-1-1 uk-flex uk-flex-middle uk-margin-small-left">
                    <button class="uk-button uk-button-link uk-link-orange" @click.prevent="removeAllTags">{{ $t("message.clear_all") }}</button>
                </div>
            </div>
        </div>
        <div v-if="webinarsList.length && upcomingWebinarsCounter === 0 && pastWebinarsCounter === 0" class="uk-margin-xlarge-top">
            <img src="/wp-content/themes/datarobot6/assets/images/no-events-image.svg" alt="No webinars by selected parameters" loading="lazy">
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import FilterTag from './Filter-tag.vue'
    import {WebinarBus} from "../../../../templates/webinars";

    export default {
        name: "ActiveFilter",
        components: {
            'dr-filter-tag': FilterTag
        },
        data () {
            return {
                upcomingCounter: 0,
                pastCounter: 0
            }
        },
        computed: {
            ...mapGetters([
                'checkedFilter',
                'pastWebinarsCounter',
                'upcomingWebinarsCounter',
                'selectedDate',
                'webinarsList'
            ]),
            list_status_message: function(){
                if (this.upcomingWebinarsCounter > 0) {
                    return this.$t('message.title');
                }

                if (this.webinarsList && this.webinarsList.length && this.upcomingWebinarsCounter === 0 && this.pastWebinarsCounter === 0) {
                    return this.$t("message.no_webinars");
                }

                return false;
            }
        },
        methods: {
            removeAllTags() {
                this.$store.dispatch('removeAllFilters');
                WebinarBus.$emit('REMOVE_CALENDAR_VALUE');
            }
        },
    }
</script>

<style lang="scss">
    .dr-active-filter-title {
        min-height: 44px;
    }
</style>
